import React from 'react';

import Typography from '../typography/typography';

import './vehicle-license-vin-details.scss';

interface VehicleLicenseVinDetailProps {
  className?: string;
  license?: string;
  vin?: string;
}

function VehicleLicenseVinDetails(props: VehicleLicenseVinDetailProps) {
  const { className = '', license, vin } = props;
  return (
    <div
      className={`vehicle-license-vin-details ${className}`}
      styleName="container"
    >
      {license && (
        <Typography
          className="vehicle-license-vin-details__license-container"
          styleName="license-container"
          tag="div"
        >
          <Typography
            className="vehicle-license-vin-details__license-title"
            size="small"
            styleName="license-title"
            tag="span"
            weight="bold"
          >
            License Plate:
          </Typography>
          <Typography
            className="vehicle-license-vin-details__vehicle-title"
            size="small"
            styleName="vehicle-title"
            tag="span"
          >
            {license}
          </Typography>
        </Typography>
      )}
      {vin && (
        <Typography
          className="vehicle-license-vin-details__vin-container"
          styleName="vin-container"
          tag="div"
        >
          <Typography
            className="vehicle-license-vin-details__vin-title"
            size="small"
            styleName="vin-title"
            tag="span"
            weight="bold"
          >
            VIN:
          </Typography>
          <Typography
            className="vehicle-license-vin-details__vehicle-title"
            size="small"
            styleName="vehicle-title"
            tag="span"
          >
            {vin}
          </Typography>
        </Typography>
      )}
    </div>
  );
}

export default VehicleLicenseVinDetails;
